<div class="col-12 lotAnnouncementWrap">
  <div class="row">
    <div class="col-12">
      <div class="alertAnnouncement">
        <div class="leftZone">
          <img alt="announcement" src="../assets/images/announcement.svg" />
        </div>
        <div class="rightZone">
          <div class="dtlWrap">
            <h3 class="hdg" *ngIf="!auctionAnnoucement">Add Announcement</h3>
            <p class="sbHdg" *ngIf="!auctionAnnoucement">
              Added announcement will be visible on public website on lot
              catalog page.
            </p>
            <p
              class="des"
              *ngIf="auctionAnnoucement"
              [innerHTML]="auctionAnnoucement?.text"
            ></p>
          </div>
          <div class="ctaWrap" *ngIf="!auctionAnnoucement">
            <button
              class="btn btn-white-border"
              type="button"
              role="button"
              (click)="
                openAnnouncementModal(annoucementModal, announcementModes.Add)
              "
            >
              + Add Announcement
            </button>
          </div>

          <div class="ctaWrapEdit" *ngIf="auctionAnnoucement">
            <div class="for-icons">
              <a
                class="hover-icon edit-icon-colored mr-2 custom-tooltip custom-tooltip2"
                #tooltip="matTooltip"
                matTooltip="Edit"
                matTooltipClass="custom-tooltip-icon"
                [matTooltipPosition]="'above'"
                role="button"
                (click)="
                  openAnnouncementModal(
                    annoucementModal,
                    announcementModes.Edit
                  )
                "
              ></a>

              <a
                class="hover-icon del-icon-colored mr-2 custom-tooltip custom-tooltip2"
                #tooltip="matTooltip"
                matTooltip="Delete"
                matTooltipClass="custom-tooltip-icon"
                [matTooltipPosition]="'above'"
                role="button"
                (click)="
                  openAnnouncementModal(
                    annoucementModal,
                    announcementModes.Remove
                  )
                "
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #annoucementModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{
        currentAnnouncementMode === announcementModes.Add
          ? "Add"
          : currentAnnouncementMode === announcementModes.Edit
          ? "Edit"
          : "Remove"
      }}
      Announcement
    </h4>
    <button
      type="button"
      class="close pull-right p-0 m-0"
      aria-label="Close"
      role="button"
      (click)="closeModal()"
    >
      <img alt="cross" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body pt-0 pb-4">
    <ng-container
      *ngIf="
        currentAnnouncementMode === announcementModes.Remove;
        else showEditor
      "
    >
      <h6 class="modal-inner-hdg mb-3">
        Are you sure want to remove announcement ?
      </h6>
    </ng-container>
    <ng-template #showEditor>
      <p class="announceNote mb-3">
        Add announcement for - '{{ auction.title }}'
      </p>
      <p class="des announceEditor editorMin250">
        <editor
          [initialValue]="announcementText"
          (editorData)="editorContent($event, announcementControl)"
          [characterLimit]="announcementMaxLength"
        ></editor>
      </p>
      <p class="announceNote mb-0">
        Note more than {{ announcementMaxLength }} characters
      </p>
    </ng-template>
    <div class="delete-btns mt-4 pt-3 pb-3">
      <button
        class="btn btn-white-border mr-3"
        role="button"
        (click)="closeModal()"
      >
        Cancel
      </button>

      <button
        class="btn btn-colored min-110"
        [disabled]="announcementControl.invalid"
        role="button"
        (click)="announcementChanges()"
      >
        {{
          currentAnnouncementMode === announcementModes.Add
            ? "Add"
            : currentAnnouncementMode === announcementModes.Edit
            ? "Update"
            : "Remove"
        }}
      </button>
    </div>
  </div>
</ng-template>
